import React, { useState } from "react";
import PropTypes from "prop-types";
import { useWatch, useFormContext } from "react-hook-form";
import classnames from "classnames";
import { FormControl } from "../Form";
import FormInput from "../FormInput";
import FormHelper from "../FormHelper";

const Textarea = ({ name, options, className }) => {
  const {
    register,
    control,
    formState: { errors },
  } = useFormContext();
  const currentValue = useWatch({
    control,
    name,
  });
  const [isFocused, setIsFocused] = useState(false);

  const hasValue = typeof currentValue !== "undefined" && currentValue !== "";
  const currentError = errors[name];

  const handleFocus = () => {
    setIsFocused(!isFocused);
  };

  const handleBlur = (e) => {
    setIsFocused(false);
  };

  return (
    <FormControl
      className={classnames({
        "is-hidden": options?.hidden,
      })}
    >
      <FormInput
        type="text"
        className={classnames(className, {
          "has-value": hasValue,
          "has-error": currentError,
          "is-active": !options?.readOnly && isFocused,
          "is-disabled": options?.disabled,
        })}
      >
        <textarea
          id={name}
          disabled={options?.disabled}
          readOnly={options?.readOnly}
          placeholder={options?.placeholder}
          rows={options?.rows}
          onFocus={handleFocus}
          {...register(name, { ...options, onBlur: handleBlur })}
        />
      </FormInput>

      {currentError && <FormHelper error={currentError} />}
    </FormControl>
  );
};

Textarea.propTypes = {
  name: PropTypes.string,
  options: PropTypes.object,
  className: PropTypes.string,
};

Textarea.defaultProps = {
  options: {
    placeholder: "Enter text here",
  },
};

export default Textarea;
